export default __webpack_public_path__ + "static/media/course_default_image.3b842b4c.png";